import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setShow(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setShow(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[#18181b] border border-white/10 rounded-xl shadow-2xl shadow-black/50 overflow-hidden">
        <div className="p-5 sm:p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-[#DFFF00]/10 flex items-center justify-center flex-shrink-0">
              <Cookie className="h-5 w-5 text-[#DFFF00]" />
            </div>
            <div className="flex-1">
              <h3 className="text-white font-bold text-lg mb-2">Vi bruger cookies</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">
                Vi bruger cookies for at forbedre din oplevelse på FitrackR. Nødvendige cookies sikrer, at siden fungerer korrekt. 
                Analytiske cookies hjælper os med at forstå, hvordan du bruger siden.{" "}
                <Link to="/cookies" className="text-[#DFFF00] hover:underline">Læs mere om vores cookies</Link>.
              </p>
            </div>
            <button 
              onClick={() => setShow(false)} 
              className="text-zinc-500 hover:text-white p-1 -mt-1 -mr-1"
              aria-label="Luk"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 mt-5">
            <Button 
              onClick={acceptAll}
              className="bg-[#DFFF00] text-black hover:bg-[#C8E600] font-bold rounded-lg h-11 px-6"
              data-testid="accept-all-cookies"
            >
              Acceptér alle
            </Button>
            <Button 
              onClick={acceptNecessary}
              variant="outline"
              className="border-zinc-700 text-zinc-300 hover:bg-zinc-800 hover:text-white rounded-lg h-11 px-6"
              data-testid="accept-necessary-cookies"
            >
              Kun nødvendige
            </Button>
            <Link to="/cookies" className="sm:ml-auto">
              <Button 
                variant="ghost"
                className="text-zinc-500 hover:text-white rounded-lg h-11 w-full sm:w-auto"
              >
                Cookie-indstillinger
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
